(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var FormView = require('../views/form')
  , ListView = require('../views/list')
  , Collection = require('../collections/feedback')
  , Model = require('../models/feedback')
  , ShowCollection = require('../../contract/collections/show')
  , debug = require('../../../../admin/source/js/app/lib/debug')('contract router')

module.exports = function (serviceLocator) {
  var router = serviceLocator.router
    , displayName = { singular: 'Feedback', plural: 'Feedback' }
    , collection = new Collection()
    , showCollection = new ShowCollection()

  router.route('contracts/show/:showId/feedback(/)', 'createFeedback', function (showId) {
    if (!serviceLocator.allow('contract', 'createFeedback')) {
      return false
    }

    debug('show create feedback view route triggered')

    showCollection.retrieve(showId, function (err, show) {
      collection.showId = showId
      collection.isArtist = true

      collection.fetch(
        { success: function () {
            var model

            if (collection.length === 1) {
              model = collection.first()
            } else {
              model = new Model({}, { collection: collection })
            }

            var view = new FormView(
                { serviceLocator: serviceLocator
                , model: model
                , show: show
                })

            router.render(view, displayName.plural)
          }
        , error: function (err) {
            // @todo: add error handling
            console.err(err)
          }
        })
    })
  })

  router.route('contracts/show/:showId/view-feedback(/)', 'viewFeedback', function (showId) {
    // if (!serviceLocator.allow('contract', 'viewFeedback')) {
    //   return false
    // }

    debug('show view feedback route triggered')

    showCollection.retrieve(showId, function (err, show) {
      collection.showId = showId

      var filter =
        { show: showId
        }

      collection.fetch(
        { data: { filter: JSON.stringify(filter) }
        , success: function () {
            var view = new ListView(
              { serviceLocator: serviceLocator
              , collection: collection
              , show: show
              })

            router.render(view, displayName.plural)

            view.on('back', function () {
              router.navigate('contracts/shows', { trigger: true })
            })
          }

        , error: function (err) {
            // @todo: add error handling
            console.err(err)
          }
        })
    })
  })
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/admin/feedback/controllers/controller.js","/components/admin/feedback/controllers")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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